export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      code: 200000,
      meta: {
        rank: 1,
        total: 3
      },
      data: [
        {
          code: '02-01-01',
          full_name: 'あいうえおあいうえお',
          name: '1-1あいうえお'
        },
        {
          code: '02-01-02',
          full_name: 'あいうえおあいうえお',
          name: '1-2あいうえお'
        },
        {
          code: '02-01-03',
          full_name: 'あいうえおあいうえお',
          name: '1-3あいうえお'
        }
      ]
    }
  }
}
